/*
 * File per la definizione dei Controller Angular:
 * https://code.angularjs.org/1.5.8/docs/guide/controller
 */
define([
    'angular'
],

    function (angular) {

        var variazioneFigureControllers = angular.module('variazioneFigureControllers', []);

        variazioneFigureControllers.controller('VariazioneFigureCtrl', ['$rootScope', '$scope', '$log', '$timeout', '$window', '$http', 'CONSTANTS', 'MessageService', 'ResourceService', 'FileProvider', VariazioneFigureCtrl]);

        function VariazioneFigureCtrl($rootScope, $scope, $log, $timeout, $window, $http, CONSTANTS, MessageService, ResourceService, FileProvider) {
            var vm = this;
            vm.invioClicked = false;

            vm.formRicerca = undefined;
            vm.input = {};
            vm.annullata = false;
            vm.datiInvio = undefined;
            vm.inputCaptcha = "";
            vm.pulsantiVisibili = false;
            vm.variazioneClicked = false;
            vm.abilitaDelegaVariazione = false;
            vm.fileOK = false;
            vm.pdfClicked = false;
            vm.invioVariazioneClicked = false;
            vm.annullaClicked = false;
            vm.operazione = undefined;
            vm.datiOriginali = undefined;
            vm.variazione = false;
            //services
            vm.MessageService = MessageService;
            vm.MessageService.clearMessages();
            
            vm.actionDisabled = function () {
                if (vm.formRicerca.$invalid || vm.invioClicked) {
                    return true;
                }
                return false;
            }

            vm.annullaOperazione = function () {
                angular.element("#modal-conferma").modal('show');
            }

            vm.annulla = function () {
                angular.element("#modal-conferma").modal('hide');
                $timeout(function () {
                    vm.input = {};
                    vm.invioClicked = false;
                    vm.formRicerca.$setPristine();
                    MessageService.clearMessages();
                    $window.scroll(0, 0);
                }, 500);
            }

            vm.confermaOperazione = function (operazione) {
                vm.operazione = operazione;
                if (vm.operazione == 'ricerca') {
                    vm.operazione = 'proseguire';
                }
                vm.operazioneLabel = 'di ' + vm.operazione;
                if (vm.operazione == 'inserire') {
                    vm.operazioneLabel = "l'inserimento della delega";
                }

                angular.element("#modal-conferma").modal('show');
            }

            vm.conferma = function () {
                angular.element("#modal-conferma").modal('hide');
                vm.invioClicked = true;
                var data = vm.input;
                $timeout(function () {
                    if (vm.operazione == 'proseguire') { // � stato modificato per visualizzare l'etichetta nella modal di conferma per l'operazione di ricerca iniziale della variazione figure prima di accedere alla pagina dei pulsanti
                        $window.scroll(0, 0);
                        ResourceService.variazioneRicerca(data, vm.inputCaptcha).then(
                            function (response) {
                              console.log("VarRic",response)
                              $window.sessionStorage.setItem("captcha", vm.inputCaptcha);
                                vm.input = {};
                                vm.invioClicked = false;
                                vm.disInserimento = true;
                                vm.disStampa = true;
                                vm.disInvio = true;
                                vm.disAnnulla = true;
                                vm.formRicerca.$setPristine();
                                vm.datiInvio = response.data;
                                vm.datiOriginali = response.data;
                                vm.reloadCaptcha();
                                if (vm.datiInvio) {
                                	if(vm.datiInvio.statoRichiesta == '1')
                                	{
                                        vm.disStampa = false;
                                        vm.disInvio = false;
                                        vm.disAnnulla = false;
                                    } else if(vm.datiInvio.statoRichiesta == '-1' || vm.datiInvio.statoRichiesta == '0' || vm.datiInvio.statoRichiesta == '3' || vm.datiInvio.statoRichiesta >= '5')
                                    {
                                        vm.disInserimento = false;

                                    } else if(vm.datiInvio.statoRichiesta == '2' || vm.datiInvio.statoRichiesta == '4')
                                    {
                                        vm.disStampa = false;
                                    }

                                	/*if(vm.datiInvio.statoRichiesta == '-1' || vm.datiInvio.statoRichiesta == '0' || vm.datiInvio.statoRichiesta == '6')
                                	{
                                		vm.disabilitato = true;
                                	}else
                                	{
                                		vm.disabilitato = false;
                                	}*/
                                    //vm.disabilitato = ["-1", "0", "6"].includes(vm.datiInvio.statoRichiesta);
                                    vm.pulsantiVisibili = true;
                                }
                                
                                MessageService.clearMessages();
                                var message = {};
                                message.severity = 'SUCCESS';
                                message.message = angular.copy(response.data.infoMessage);
                                MessageService.setMessages([message]);
                                MessageService.showMessages();
                                vm.datiInvio.infoMessage = undefined;
                            }, function (response) {
                                $log.error(response);
                                vm.invioClicked = false;
                                vm.pulsantiVisibili = false;
                                vm.reloadCaptcha();
//                                vm.inputCaptcha= $window.sessionStorage.getItem("captchaRandom");
//                                $window.sessionStorage.setItem("captcha",$window.sessionStorage.getItem("captchaRandom"));
                                response.data.messages[0].severity = 'ERROR';
                                //response.data.messages[0].message = 'Si \u00E8 verificato un errore durante il caricamento dei dati.'
                                MessageService.setMessages(response.data.messages);
                                MessageService.showMessages();

                            });
                    } else
                    {
                        vm.invio(vm.operazione);
                    }
                }, 500);
            }

            vm.initFn = function (loadImg) {
                vm.reloadCaptcha = loadImg;
            }

            vm.redirectTo = function (operazione) {
                MessageService.clearMessages();

                if (operazione == 'inserimento') {
                    var data = 
                    {
                        cfEnte: vm.datiInvio.cfEnte,
                        protocolloRichiesta: vm.datiInvio.protocolloRichiesta
                    }
                    var captcha = $window.sessionStorage.getItem("captcha");
                    ResourceService.variazioneControlloInserimento(data, captcha).then(
                        function(response){
                            vm.pulsantiVisibili = false;
                            vm.variazioneClicked = true;
                            vm.datiInvio = response.data;
                            vm.datiOriginali = response.data;
                            vm.reloadCaptcha();
                            $window.scroll(0, 0);
                        },function(response){
                            
                            $log.error(response);
                            vm.pulsantiVisibili = true;
                            vm.annullaClicked = false;
                            response.data.messages[0].severity = 'ERROR';
                            MessageService.setMessages(response.data.messages);
                            MessageService.showMessages();
                        }
                    )
                   
                }
                else if (operazione == 'scaricaPDF') {
                    vm.pulsantiVisibili = false;
                    vm.pdfClicked = true;
                    $window.scroll(0, 0);
                }
                else if (operazione == 'invio') {
                    var data = 
                    {
                        cfEnte: vm.datiInvio.cfEnte,
                        protocolloRichiesta: vm.datiInvio.protocolloRichiesta
                    }
                    var captcha = $window.sessionStorage.getItem("captcha");
                    ResourceService.variazioneControlloInviaRichiesta(data, captcha).then(
                        function(response){
                            vm.pulsantiVisibili = false;
                            vm.invioVariazioneClicked = true;
                            $rootScope.abilitaDelega = true;
                            vm.reloadCaptcha();
                            $window.scroll(0, 0);
                        },function(response){
                            $log.error(response);
                            response.data.messages[0].severity = 'ERROR';
                            MessageService.setMessages(response.data.messages);
                            MessageService.showMessages();
                        }
                    )
                    
                }
                else if (operazione == 'annulla') {
                    var captcha = $window.sessionStorage.getItem("captcha");
                    debugger;
                    var data = '{ "denominazione": "' + vm.datiInvio.denominazione + '", "cfEnte": "' + vm.datiInvio.cfEnte + '", "protocolloRichiesta": "' + vm.datiInvio.protocolloRichiesta + '" }';
                    ResourceService.variazioneRichiestaAnnulla(data, captcha).then(
                        function (response) {
                           
                            vm.pulsantiVisibili = false;
                            vm.annullaClicked = true;
                            $window.scroll(0, 0);
                            vm.datiAnnulla = response.data;
                            vm.pulsantiVisibili = false;
                            vm.annullaClicked = true;
                            $window.scroll(0, 0);
                            MessageService.clearMessages();
                            var message = {};
                            message.severity = 'SUCCESS';
                            message.message = angular.copy(vm.datiInvio.infoMessage);
                            MessageService.setMessages([message]);
                            MessageService.showMessages();
                        }, function (response) {
                            $log.error(response);
                            vm.pulsantiVisibili = true;
                            vm.annullaClicked = false;
                            vm.variazioneSalvata = false;
                            response.data.messages[0].severity = 'ERROR';
                            MessageService.setMessages(response.data.messages);
                            MessageService.showMessages();
                        });
                }
            }

            vm.indietro = function () {
                vm.pulsantiVisibili = true;
                vm.invioVariazioneClicked = false;
                $rootScope.abilitaDelega = false;
                MessageService.clearMessages();
            }

            vm.invio = function (operazione) {
                if (operazione == 'inviare') {
                    var data = '{ "cfEnte": "' + vm.datiInvio.cfEnte + '", "denominazione": "' + vm.datiInvio.denominazione + '", "protocolloRichiesta": "' + vm.datiInvio.protocolloRichiesta + '", "fileDelega": "' + vm.datiInvio.fileDelega + '" }';
                    ResourceService.variazioneInvio(data, vm.inputCaptcha).then(function (response) {
                        vm.pulsantiVisibili = true;
                        vm.invioVariazioneClicked = false;
                        $rootScope.abilitaDelega = false;
                        vm.datiInvio.infoMessage = response.data;
                        vm.disInserimento = true;
                        vm.disInvio = true;
                        vm.disAnnulla = true;
                        MessageService.clearMessages();
                        var message = {};
                        message.severity = 'SUCCESS';
                        message.message = angular.copy(vm.datiInvio.infoMessage);
                        MessageService.setMessages([message]);
                        MessageService.showMessages();
                        vm.reloadCaptcha();
                    }, function (response) {
                        $log.error(response);
                        vm.pulsantiVisibili = false;
                        vm.invioVariazioneClicked = true;
                        response.data.messages[0].severity = 'ERROR';
                        MessageService.setMessages(response.data.messages);
                        MessageService.showMessages();
                        vm.reloadCaptcha();
                });
                } else if (operazione == 'inserire') {
                    var data = vm.datiInvio;
                    data.azione = 'valida';
                    data.infoMessage = undefined;
                    ResourceService.variazioneSalvaInvioDelega(data, vm.inputCaptcha).then(function (response) {
                        vm.abilitaDelegaVariazione = false;
                        vm.pulsantiVisibili = true;
                        $rootScope.abilitaDelega = false;
                        vm.datiInvio = response.data;
                        vm.disInserimento = true;
                        vm.disStampa = false;
                        vm.disInvio = false;
                        vm.disAnnulla = false;
                        MessageService.clearMessages();
                        var message = {};
                        message.severity = 'SUCCESS';
                        message.message = 'Operazione di acquisizione dei dati correttamente effettuata. Cliccando sul Pulsante "Scarica Pdf Richiesta Richiesta Variazione" il sistema genera un file in formato "Pdf" che riepiloga tutte le informazioni inserite. Tale file viene spedito anche all’indirizzo email nominale del Responsabile di Convenzione indicato e, dopo essere stato sottoscritto digitalmente a cura del Rappresentante legale dell\'Ente, deve essere inviato all\'Agenzia attraverso l\'apposito tasto denominato "invio richiesta" entro 30 giorni dalla generazione del file altrimenti la richiesta verrà automaticamente cancellata. È possibile annullare la richiesta di modifica pendente prima del definitivo invio attraverso il tasto "Annulla Richiesta di Modifica". In questo modo sarà possibile ripresentare una nuova richiesta d\'aggiornamento.';
                        MessageService.setMessages([message]);
                        MessageService.showMessages();
                        vm.reloadCaptcha();
                    }, function (response) {
                        $log.error(response);
                        $rootScope.abilitaDelega = true;
                        vm.abilitaDelegaVariazione = true;
                        vm.pulsantiVisibili = false;
                        response.data.messages[0].severity = 'ERROR';
                        MessageService.setMessages(response.data.messages);
                        MessageService.showMessages();
                        vm.reloadCaptcha();
                    });
                }
            }
        };

        return variazioneFigureControllers;
    });


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/controllers/variazione-figure-controllers.js
// module id = 36
// module chunks = 1